import { HIS_PAST_OPTIONS } from '../HIS_PAST_OPTIONS';
import { HisPastOptionIdType } from '../types';

export const getHisPastTitleById = (
  id: HisPastOptionIdType | null | undefined,
): string | null => {
  if (!id) return null;
  return HIS_PAST_OPTIONS.find((option) => option.id === id)?.title || null;
};

const DEFAULT: HisPastOptionIdType = 'recently_single';
export const getHisPastIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): HisPastOptionIdType | null => {
  const id = HIS_PAST_OPTIONS.find((option) => option.title === title)?.id;
  if (id) {
    return id;
  }
  if (withDefault) {
    return DEFAULT;
  }
  return null;
};
